var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count-wrp"},[_c('span',{staticClass:"calc-btn sub",class:{on: +_vm.result > +_vm.min},on:{"click":_vm.onReduce}}),_vm._v(" "),_c('span',{staticClass:"result"},[_vm._v(_vm._s(_vm.result))]),_vm._v(" "),_c('span',{staticClass:"calc-btn plus",class:{on: +_vm.result < +_vm.max},on:{"click":_vm.onPlus}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99d26158","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BgCount/BgCount.vue
// module id = null
// module chunks = 